import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFocusElement, toggleRightDrawer } from '../../../store/global/actions';
import { getRightDrawerStatus } from '../../../store/global/selectors';
import { createPortal } from 'react-dom';
import { useReactFlow, useStore } from 'react-flow-renderer';

export default function NodeHelperPopup({
    nodeData,
    title,
    nodeId,
    nodeType,
    subType,
    templateId,
    customHelperText,
    customType
}) {
    const dispatch = useDispatch();
    const rightDrawerStatus = useSelector(getRightDrawerStatus);

    const reactFlow = useReactFlow();

    // Listen to viewport changes (zoom / pan)
    const transform = useStore((state) => state.transform);

    const [position, setPosition] = useState(null);

    const nodesWithTopHanldle = ["analytics", "clusterlet"];

    useEffect(() => {
        const node = reactFlow.getNode(nodeId);
        if (!node) return;

        const el = document.getElementById(`node-${nodeId}`);
        if (!el) return;
        const rect = el.getBoundingClientRect();

        const [x, y, zoom] = transform;

        // Node position in flow space
        const nodeY = node.positionAbsolute?.y ?? node.position.y;

        // Convert to screen coords
        let screenY = nodeY * zoom + y;
        
        screenY = nodesWithTopHanldle.includes(nodeType) ? screenY - 4 : screenY;

        setPosition({
            top: screenY,
            left: rect.left + rect.width / 2
        });

    }, [nodeId, transform, reactFlow]);

    const handleSeeDetails = (e) => {
        e.stopPropagation();

        dispatch(
            setFocusElement({
                id: nodeId,
                type: nodeType,
                subType,
                name: nodeData.label,
                protocol: nodeData.protocol,
                icon: nodeData.icon,
                desc: nodeData.desc,
                templateId: templateId || ''
            })
        );

        if (!rightDrawerStatus) {
            dispatch(toggleRightDrawer());
        }
    };

    const stopAll = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (e.nativeEvent) {
            e.nativeEvent.stopImmediatePropagation();
        }
    };


    if (!nodeData?.showHelper || !position) return null;


    return createPortal(
        <div
            className="node-helper-popup nodrag nopan"
            onClick={stopAll}
            id={`node_details_popup_${nodeData.label}`}
            onMouseDown={stopAll}
            onPointerDown={stopAll}
            onDoubleClick={stopAll}
            style={{
                position: 'fixed',
                top: position.top,
                left: position.left,
                transform: 'translate(-50%, -100%)',
                background: '#ffffff',
                border: '1px solid #d0d0d0',
                borderRadius: '8px',
                width: '250px',
                maxWidth: '300px',
                padding: '8px 10px',
                fontSize: '8px',
                zIndex: 1195,
                boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
                fontFamily: 'Roboto, Helvetica',
                pointerEvents: 'none'
            }}
        >
            <div
                style={{
                    fontSize: '13px',
                    fontWeight: 600,
                    color: '#222',
                    marginBottom: '2px'
                }}
            >
                {nodeData.label}
            </div>

            <div
                style={{
                    fontSize: '12px',
                    fontWeight: 500,
                    color: '#777',
                    marginBottom: '6px'
                }}
            >
                {customType || title}
            </div>

            <div
                style={{
                    fontSize: '11px',
                    color: '#444',
                    lineHeight: 1.5,
                    maxHeight: '120px',
                    overflowY: 'auto'
                }}
            >
                {customHelperText ||
                    nodeData.helperText ||
                    nodeData.desc ||
                    'No description'}
            </div>

            {/* <div
                className="nodrag nopan"
                style={{
                    fontSize: '12px',
                    fontWeight: 500,
                    color: '#1976d2',
                    cursor: 'pointer',
                    textAlign: 'right',
                    userSelect: 'none',
                    padding: '4px'
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    handleSeeDetails(e);
                }}
                onMouseEnter={(e) =>
                    (e.currentTarget.style.textDecoration = 'underline')
                }
                onMouseLeave={(e) =>
                    (e.currentTarget.style.textDecoration = 'none')
                }
            >
                See Details →
            </div> */}
        </div>,
        document.body
    );
}
